import React, { useEffect, useContext } from 'react';
import DetailsListTable from './DetailsListTable';
import { TablePagination } from '../../../shared/components/table/TablePagination';
import { SkeletonTable } from '../../../shared/components/Skeleton';
import useMyWorkListFunctions from './useMyWorkListFunctions';
import { MyWorkContext } from '../MyWorkContextProvider';
import { getSelectedTabFromStorage } from './myWorkListHelper';
import { Route } from '../../../../route-constants';
import { useLocation } from 'react-router-dom';
import { ResultCount } from '../../../shared/components/ResultCount';
import { appState } from '../../../AppState';

const MyWorkList = () => {
  const currentState = appState(); 
  const { moveToPage, countPerPage, getpaginatedMyWorkList, setMyWorkListInterval } = useMyWorkListFunctions(currentState);
  const { myWorkStates } = useContext(MyWorkContext);
  const location = useLocation();
  const isMyGroupWork = location.pathname.includes(Route.myGroupWork.pagePath);

  useEffect(() => {
    getpaginatedMyWorkList({});
    const timer = setMyWorkListInterval();
    return () => { clearInterval(timer); };
  }, []);

  return myWorkStates.myWorkList.isFetching ? (
    <SkeletonTable />
  ) : (
    <>
      <div style={{ height: 'calc(100vh - 106px - 2.25rem)', overflow: 'auto' }}>
        <DetailsListTable />
      </div>
      <div className='pr-4 h-9 flex items-center'>
        <ResultCount count={myWorkStates.myWorkList.dataCount[getSelectedTabFromStorage(isMyGroupWork) ?? myWorkStates.myWorkList.selectedTabId]} />
        <TablePagination currentPage={myWorkStates.myWorkList.currentPage} totalCount={myWorkStates.myWorkList.dataCount[getSelectedTabFromStorage(isMyGroupWork) ?? myWorkStates.myWorkList.selectedTabId]}
          moveToPage={moveToPage} itemsPerPage={myWorkStates.myWorkList.countPerPage} itemsPerPageChanged={countPerPage} />
      </div>
    </>
  );
};

export default MyWorkList;
